<template>
    <div class="lp-location-finder-list__locations" v-if="visibleLocations.length > 0">
        <location-list-item v-for="(location, index) in visibleLocations"
            :location="location"
            :index="index"
            :details-url="detailsUrl" 
            :enable-details="enableDetails"
        />
    </div>
    <p v-else class="h4">No locations match the current filter.</p>
</template>
<script>
    import LocationListItem from "./LocationListItem.vue";
    export default {
        components: { LocationListItem },
        name: 'LocationList',
        props: {
            visibleLocations: {
                type: Array,
                required: true
            },
            detailsUrl: {
                type: String,
                required: true
            },
            enableDetails: {
                type: Boolean,
                required: true
            }
        },
        setup: (props) => {
        }
    }
</script>

<style lang="scss" scoped></style>